import { useState } from "react";
import axios from "axios";
import './AdminLogin.css';
import video1 from "../../Images/video1.mp4";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState('');
    const navigate = useNavigate();

  const validate = () => {
    const newErrors = {};
    if (!email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = "Email is invalid";
    }

    if (!password) {
      newErrors.password = "Password is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  if (validate()) {
    try {
      const response = await axios.post('https://spinelleapi.emedha.in/admin/auth/api/admin-login', {
        email,
        password
      });

      if (response.data.success) {
        toast.success("Login Successful ✦", {
          position: "top-right",
          autoClose: 3000,
          theme: "colored"
        });
               sessionStorage.setItem("isAdminLoggedIn", "true");
        setTimeout(() => {
          navigate('/admin-dashboard');
        }, 2000);
      } else {
        toast.error(response.data.message, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored"
        });
      }
    } catch (error) {
      toast.error("Server Error. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        theme: "colored"
      });
    }
  }
};


  return (
    <div className="admin-login-container">
      <video autoPlay muted loop className="bg-video">
        <source src={video1} type="video/mp4" />
      </video>

      <div className="overlay"></div>

      <div className="top-right-logo">SPINELLE ✦</div>

      <div className="login-card">
        <h1>Welcome to Spinelle Admin</h1>
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Email Address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          {errors.email && <span className="error-message">{errors.email}</span>}

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          {errors.password && <span className="error-message">{errors.password}</span>}

          {apiError && <span className="error-message">{apiError}</span>}

          <button type="submit">Login</button>
        </form>
      </div>
          <ToastContainer />
    </div>
  );
}
